var _circle, _circle2, _circle3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 80.0001,
    cy: 80.0001,
    r: 65.3064,
    stroke: "#FE4A49",
    strokeDasharray: "14 14"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 80,
    cy: 80,
    r: 50.4677,
    stroke: "#FE4A49",
    strokeDasharray: "14 14"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 80,
    cy: 80,
    r: 79.5,
    stroke: "#FE4A49",
    strokeDasharray: "14 14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 40C102.092 40 120 57.908 120 80C120 102.092 102.092 120 80 120C57.908 120 40 102.092 40 80C40 57.908 57.908 40 80 40ZM80 96C78.9391 96 77.9217 96.4214 77.1716 97.1716C76.4214 97.9217 76 98.9391 76 100C76 101.061 76.4214 102.078 77.1716 102.828C77.9217 103.579 78.9391 104 80 104C81.0609 104 82.0783 103.579 82.8284 102.828C83.5786 102.078 84 101.061 84 100C84 98.9391 83.5786 97.9217 82.8284 97.1716C82.0783 96.4214 81.0609 96 80 96ZM80 58C76.1544 58 72.4662 59.5277 69.747 62.247C67.0277 64.9662 65.5 68.6544 65.5 72.5C65.5 73.5609 65.9214 74.5783 66.6716 75.3284C67.4217 76.0786 68.4391 76.5 69.5 76.5C70.5609 76.5 71.5783 76.0786 72.3284 75.3284C73.0786 74.5783 73.5 73.5609 73.5 72.5C73.5013 71.3201 73.8238 70.1629 74.4327 69.1524C75.0417 68.1418 75.9143 67.3161 76.9568 66.7637C77.9994 66.2113 79.1726 65.9531 80.3508 66.0168C81.5289 66.0804 82.6675 66.4636 83.6444 67.1251C84.6214 67.7866 85.3999 68.7016 85.8964 69.7719C86.3929 70.8422 86.5888 72.0274 86.4629 73.2006C86.3371 74.3737 85.8943 75.4904 85.1821 76.4311C84.4699 77.3717 83.515 78.1007 82.42 78.54C79.716 79.62 76 82.388 76 87V88C76 89.0609 76.4214 90.0783 77.1716 90.8284C77.9217 91.5786 78.9391 92 80 92C81.0609 92 82.0783 91.5786 82.8284 90.8284C83.5786 90.0783 84 89.0609 84 88C84 87.024 84.2 86.536 85.044 86.12L85.392 85.96C88.5153 84.7036 91.1042 82.3998 92.7149 79.4437C94.3257 76.4875 94.858 73.0631 94.2205 69.7575C93.583 66.4519 91.8155 63.471 89.221 61.3259C86.6264 59.1807 83.3665 58.0049 80 58Z",
    fill: "#FE4A49"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionRed);
export default __webpack_public_path__ + "static/media/question-red.0e450d0fe1d44d416fdc766284668c94.svg";
export { ForwardRef as ReactComponent };